/* src/app/forms/produtos/mercadolivre/meli-mlb-download/meli-mlb-download.component.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.view-component {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  background: var(--tem-surface);
  border: 1px solid var(--tem-border);
  border-radius: var(--tem-radius);
  box-shadow: var(--tem-shadow);
}
.content {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;
  padding: 14px;
  gap: 14px;
}
.toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.toolbar__company {
  flex: 0 1 280px;
  min-width: 220px;
}
.toolbar__company nz-select {
  width: 100%;
}
.toolbar__search {
  flex: 1 1 300px;
}
.toolbar__go {
  flex: none;
}
.toolbar__mode {
  flex: none;
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--tem-muted);
  font-weight: 600;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
}
.clear-icon {
  cursor: pointer;
  color: var(--tem-muted);
}
.clear-icon:hover {
  color: var(--tem-danger);
}
.melicontainer {
  display: flex;
  gap: 14px;
  height: 100%;
  min-height: 0;
}
.panel {
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.panel--results {
  flex: 1 1 70%;
  position: relative;
}
.panel--results.panel--full {
  flex-basis: 100%;
}
.panel--filters {
  flex: 0 0 30%;
  min-width: 260px;
  gap: 12px;
  padding: 14px;
  background: var(--tem-surface);
  border: 1px solid var(--tem-border);
  border-radius: var(--tem-radius);
  overflow: auto;
}
.filter-radio-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.filter-radio-group ::ng-deep .ant-radio-wrapper {
  margin-right: 0;
  font-weight: 600;
}
.information {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  padding: 10px 14px;
  margin-bottom: 14px;
  background: var(--tem-surface-2);
  border: 1px solid var(--tem-border);
  border-radius: var(--tem-radius);
}
.information__count {
  flex: 1;
  color: var(--tem-muted);
}
.information__count strong {
  color: var(--tem-ink);
}
.information__actions {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}
.importados-select {
  min-width: 170px;
}
.vl {
  width: 1px;
  align-self: stretch;
  background: var(--tem-border);
  margin: 0 4px;
}
.detail {
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding: 12px;
  border: 1px solid var(--tem-border);
  border-radius: var(--tem-radius);
  background: var(--tem-bg);
}
.cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 12px;
  align-content: start;
}
.update-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  background: var(--tem-surface);
  border: 1px solid var(--tem-border);
  border-radius: var(--tem-radius);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.update-card:hover {
  border-color: var(--tem-deep);
  box-shadow: var(--tem-shadow);
}
.update-card--imported {
  border-color: var(--tem-accent);
  background:
    linear-gradient(
      0deg,
      var(--tem-accent-soft),
      var(--tem-accent-soft)),
    var(--tem-surface);
}
.update-card__check {
  flex: none;
}
.update-card__body {
  flex: 1;
  min-width: 0;
}
.update-card__title {
  font-weight: 600;
  color: var(--tem-ink);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.4;
}
.update-card__id {
  font-size: 0.8rem;
  color: var(--tem-muted);
  font-family:
    ui-monospace,
    SFMono-Regular,
    Menlo,
    Consolas,
    monospace;
}
.update-card__badge {
  flex: none;
  color: var(--tem-accent);
  font-size: 18px;
}
@media only screen and (max-width: 920px) {
  .melicontainer {
    flex-direction: column;
  }
  .panel--filters {
    flex-basis: auto;
    min-width: 0;
    order: -1;
  }
  .cards-grid {
    grid-template-columns: 1fr;
  }
}
/*# sourceMappingURL=meli-mlb-download.component.css.map */
